(function () {
  var SECTION_SELECTOR = '.vernal-functional-selling-points';
  var INTRO_ROTATE_SELECTOR = '[data-vfsp-intro-rotate].vernal-functional-selling-points__intro--rotate-sync';
  var INTRO_MEDIA_SELECTOR = '.vernal-functional-selling-points__intro-media';
  var MAIN_VIDEO_SELECTOR = '.vernal-functional-selling-points__main-video-wrap video';
  var ACTIVE_CLASS = 'vernal-functional-selling-points__intro--rotate-active';

  var instances = new WeakMap();

  function getVideo(section) {
    return section.querySelector(MAIN_VIDEO_SELECTOR);
  }

  function ensureVideoPlay(video) {
    if (!video || video.paused !== true) return;

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function initVideoPlayback(section) {
    var video = getVideo(section);
    if (!video) return;

    function tryPlay() {
      ensureVideoPlay(video);
    }

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('canplay', tryPlay, { once: true });
    }

    video.addEventListener('loadeddata', tryPlay, { once: true });
  }

  function startIntroAnimation(intro, media, video) {
    var duration = video.duration;
    if (!duration || !isFinite(duration)) return false;

    var durationMs = duration * 1000;
    var progress = (video.currentTime % duration) / duration;

    intro.style.setProperty('--vfsp-intro-anim-duration', durationMs + 'ms');
    intro.classList.add(ACTIVE_CLASS);

    media.style.animation = 'none';
    void media.offsetWidth;
    media.style.removeProperty('animation');
    media.style.animationDelay = -progress * durationMs + 'ms';

    return true;
  }

  function VernalFunctionalSellingPoints(section) {
    this.section = section;
    this.intro = section.querySelector(INTRO_ROTATE_SELECTOR);
    this.media = this.intro ? this.intro.querySelector(INTRO_MEDIA_SELECTOR) : null;
    this.video = getVideo(section);
    this.durationReady = false;
    this.animationStarted = false;
    this.onMetadata = this.handleMetadata.bind(this);
    this.onPlaying = this.handlePlaying.bind(this);
  }

  VernalFunctionalSellingPoints.prototype.markDurationReady = function () {
    if (!this.video || !this.video.duration || !isFinite(this.video.duration)) return;
    this.durationReady = true;
  };

  VernalFunctionalSellingPoints.prototype.tryStartAnimation = function () {
    if (this.animationStarted || !this.durationReady || !this.intro || !this.media || !this.video) {
      return;
    }

    if (this.video.paused) return;

    if (startIntroAnimation(this.intro, this.media, this.video)) {
      this.animationStarted = true;
    }
  };

  VernalFunctionalSellingPoints.prototype.handleMetadata = function () {
    this.markDurationReady();
    this.tryStartAnimation();
  };

  VernalFunctionalSellingPoints.prototype.handlePlaying = function () {
    this.markDurationReady();
    this.tryStartAnimation();
  };

  VernalFunctionalSellingPoints.prototype.start = function () {
    initVideoPlayback(this.section);

    if (!this.intro || !this.media || !this.video) return;

    this.markDurationReady();

    if (!this.durationReady) {
      this.video.addEventListener('loadedmetadata', this.onMetadata, { once: true });
      this.video.addEventListener('durationchange', this.onMetadata, { once: true });
    }

    this.video.addEventListener('playing', this.onPlaying);

    if (!this.video.paused) {
      this.tryStartAnimation();
    }
  };

  VernalFunctionalSellingPoints.prototype.destroy = function () {
    if (this.intro) {
      this.intro.classList.remove(ACTIVE_CLASS);
      this.intro.style.removeProperty('--vfsp-intro-anim-duration');
    }

    if (this.media) {
      this.media.style.removeProperty('animation');
      this.media.style.removeProperty('animation-delay');
    }

    if (!this.video) return;

    this.video.removeEventListener('loadedmetadata', this.onMetadata);
    this.video.removeEventListener('durationchange', this.onMetadata);
    this.video.removeEventListener('playing', this.onPlaying);
  };

  function initSection(section) {
    if (!section || instances.has(section)) return;

    var instance = new VernalFunctionalSellingPoints(section);
    instances.set(section, instance);
    instance.start();
  }

  function destroySection(section) {
    var instance = instances.get(section);
    if (!instance) return;
    instance.destroy();
    instances.delete(section);
  }

  function mountAll(context) {
    var scope = context || document;
    var sections =
      scope.matches && scope.matches(SECTION_SELECTOR)
        ? [scope]
        : scope.querySelectorAll(SECTION_SELECTOR);

    Array.prototype.forEach.call(sections, function (section) {
      if (!getVideo(section)) return;
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section) {
      destroySection(section);
    }
  });
})();
